<template lang="pug">
  .form-item(:class="{'-error-': error}")
    span.form-item__title.-tooltip-(v-if="title && tooltip" v-tiny-text-tooltip="{text: tooltip}")
      | {{title}}
    span.form-item__title(v-else-if="title")
      | {{title}}

    .form-item__block(ref="editor")
      MediumEditor.form-item__input.form-item__markdown(
        data-markdown-custom-event="true"
        :options="editorOptions"
        @edit="applyTextEdit"
      )
      slot
      span.form-item__error(v-if="typeof error !== 'boolean'")
        | {{error}}

</template>

<script>
import editor from 'vue2-medium-editor';
import htmlToMarkdown from '@/functions/conventerHtmlToMarkdown';
import markdownToHtml from '@/functions/converterMarkdownToHtml';

export default {
  components: {
    MediumEditor: editor
  },
  props: {
    title: {},
    error: {},
    tooltip: {},
    placeholder: {},
    value: {}
  },
  data() {
    return {
      editorOptions: {
        placeholder: {
          text: this.placeholder ? this.placeholder : 'Введите текст'
        },
        imageDragging: false,
        toolbar: {
          buttons: [
            {
              name: 'bold',
              tagNames: ['strong', 'b'],
              style: {},
              aria: 'Жирный'
            },
            {
              name: 'italic',
              aria: 'Курсив'
            },
            {
              name: 'strikethrough',
              tagNames: ['del', 'strike', 'ins'],
              useQueryState: false,
              aria: 'Зачеркивание'
            },
            {
              name: 'anchor',
              aria: 'Ссылка'
            },
            {
              name: 'h2',
              aria: 'Заголовок 2'
            },
            {
              name: 'h3',
              aria: 'Заголовок 3'
            },
            {
              name: 'orderedlist',
              aria: 'Нумерованный список'
            },
            {
              name: 'unorderedlist',
              aria: 'Маркированный список'
            }
          ]
        }
      }
    };
  },
  watch: {
    value(val) {
      if (
        val !==
        htmlToMarkdown.turndown(this.$refs.editor.childNodes[0].innerHTML)
      ) {
        this.$refs.editor.childNodes[0].innerHTML = markdownToHtml.makeHtml(
          this.value
        );
      }
    }
  },
  mounted() {
    this.$refs.editor.childNodes[0].innerHTML = markdownToHtml.makeHtml(
      this.value
    );
  },
  methods: {
    applyTextEdit() {
      const markdown = htmlToMarkdown.turndown(
        this.$refs.editor.querySelector('[data-markdown-custom-event="true"]')
      );
      this.$emit('input', markdown);
    }
  }
};
</script>

<style>
@import '~medium-editor/dist/css/medium-editor.min.css';
@import '~medium-editor/dist/css/themes/beagle.css';
</style>
